import React, { useState } from 'react';
import { StyledAppContainer } from './styles';
import { ErrorMessage } from '../components/error-message';
import { LoaderSpinner } from '@ngw6/us-components';
import { DataServer } from '../store/data-server';
import { ModelsConfigResponse, fetchModelsConfigData } from '../store/fetch/models-config';
import { FeatureAppStandalone } from './standalone';


export const App = () => {
  const [modelsConfigData, setModelsConfigData] = useState<
    ModelsConfigResponse | undefined
  >(undefined);
  const error = modelsConfigData?.errorHandling?.[0];
  const loading = !modelsConfigData;

  loading && fetchModelsConfigData(setModelsConfigData);
  return (
    <>
      {error && <ErrorMessage message1={error.errorMessage} />}
      {modelsConfigData?.fetchedModelsConfig && (
        <DataServer modelsConfig={modelsConfigData?.fetchedModelsConfig}>
            <StyledAppContainer className="special-offers-app-container">
              <FeatureAppStandalone />
            </StyledAppContainer>
        </DataServer>
      )}
      {loading && <LoaderSpinner />}
    </>
  );
};
